import { render, staticRenderFns } from "./ProfitItem.vue?vue&type=template&id=3bbe8cb1&scoped=true&"
import script from "./ProfitItem.vue?vue&type=script&lang=js&"
export * from "./ProfitItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfitItem.vue?vue&type=style&index=0&id=3bbe8cb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe8cb1",
  null
  
)

export default component.exports